import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import {
  NgbModal,
  NgbModalRef
} from "@ng-bootstrap/ng-bootstrap";
import { Subscription } from "rxjs/Subscription";
import { Constants } from "../../helper/constants";
import { AccountService } from "../../shared/account/account.service";
import { PaymentService } from "../../shared/payment/payment.service";
import { CommunityService } from "../../shared/services/community/community.service";
import { BackendService } from "../../shared/services/backend.service";
import { AuthService } from "../../shared/services/auth.service";
import { LoaderService } from "../../shared/services/loader.service";

@Component({
  selector: "app-payment-log",
  templateUrl: "./payment-log.component.html",
  styleUrls: ["./payment-log.component.scss"]
})
export class PaymentLogComponent implements OnInit, OnDestroy {
  payments;
  payment;
  billTypes;
  billType;
  loading = false;
  community;
  communityId;
  communities: Array<{}>;
  modalReference: NgbModalRef;
  private routeSubscription: Subscription;
  private paymentSubscription: Subscription;
  activeRouteIndex: number;
  page = 1;
  isAdmin: boolean;
  isCommunityManager: boolean;
  authState;
  private userId: string;
  query: string;
  order = "date";
  reverse = true;

  constructor(
    private accountService: AccountService,
    private authService: AuthService,
    private communityService: CommunityService,
    private paymentService: PaymentService,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private loaderService: LoaderService
  ) {
    this.billType = "default";
    this.payment = "";
    this.community = "";
    this.authState = this.authService.getAuthState();
    this.userId = BackendService.generateUserId(this.authState.email);
  }

  ngOnInit(): void {
    this.loaderService.startLoader();
    this.query = "";
    this.routeSubscription = this.accountService
      .getProfile(this.userId)
      .subscribe((profile: any) => {
        this.route.params.subscribe(params => {
          this.activeRouteIndex = params.index;
          const activeRole: any = profile.roles[this.activeRouteIndex];
          if (activeRole.role === Constants.USER_TYPE_ADMIN) {
            this.getCommunity(params.communityId);
            this.getPayments(params.communityId);
          } else {
            this.getPayments(activeRole.communityId);
          }
          this.loaderService.stopLoader();
        });
      });
  }

  ngOnDestroy(): void {
    this.routeSubscription.unsubscribe();
    this.paymentSubscription.unsubscribe();
  }

  viewPayment(payment, modal): void {
    this.payment = payment;
    this.open(modal);
  }

  open(modal): void {
    this.modalReference = this.modalService.open(modal);
  }

  close(): void {
    this.modalReference.close();
  }

  setSortOrder(value: string): void {
    if (this.order === value) {
      this.reverse = !this.reverse;
    }

    this.order = value;
  }

  private getPayments(communityId): void {
    this.paymentSubscription = this.paymentService
      .getPayments(communityId)
      .subscribe(payments => {
        const items = [];
        for (const payment of payments) {
          payment["status"] = payment["status"] === "full" ? "Full Payment" :
            payment["status"] === "part" ? "Part Payment" : payment["status"];
          items.push(payment);
        }

        this.payments = items;
      });
  }

  private getCommunity(communityId): void {
    this.communityService
      .getCommunityById(communityId)
      .subscribe(community => (this.community = community));
  }
}



// WEBPACK FOOTER //
// ./src/app/bill/payment-log/payment-log.component.ts